import React, { useEffect, useMemo } from 'react';
import * as leaflet from 'leaflet';
import { Marker, useMap } from 'react-leaflet';
import { INITIAL_MAP_ZOOM } from 'constants/profile';
import { MapPropsInterface } from '../types';
import navigationCursor from '../../../../assets/img/navigation-cursor.svg';

const Markers = ({ markers, width, height }: MapPropsInterface) => {
  const map = useMap();

  useEffect(() => {
    const handleResize = () => {
      map.invalidateSize();
    };
    const debounceTimeout = setTimeout(handleResize, 500);
    return () => clearTimeout(debounceTimeout);
  }, [width, height]);

  const markerIcons = useMemo(
    () =>
      markers.map(
        () =>
          new leaflet.DivIcon({
            iconUrl: navigationCursor,
            iconSize: [32, 32],
            className: 'container-icon-avatar',
            html: `<div class="wrapper-icon" data-testid="icon-wrapper"><img src="${navigationCursor}" alt="navigation-cursor" /></div>`,
          })
      ),
    [markers]
  );

  useEffect(() => {
    map.setZoom(INITIAL_MAP_ZOOM);
  }, []);

  return (
    <>
      {markers.map((pin, index) => (
        <Marker
          position={leaflet.latLng(pin.coordinates[0], pin.coordinates[1])}
          icon={markerIcons[index]}
          key="marker-icon-key"
          zIndexOffset={(index + 1) * 100}
        />
      ))}
    </>
  );
};

export default Markers;
